import React from "react";
import { connect } from "react-redux";

const mapState = (state) => {
	return {
		siniestro: state.siniestros.sinremSelect
	};
};

export class DetalleReembolso extends React.Component {

	format = (monto) => {	
	  if(monto == "" || monto == null) {
	  	return "-";
	  }
	  let cifra = parseFloat(Math.round(monto * 100) / 100).toFixed(2);
	  let total = cifra.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	  return "$ " + total;
	}

	state = {
		estatus: "",
		montoReclamado: 0,
		montoAutorizado: 0
	}

	componentWillReceiveProps(nextProps) {
		if(this.props.siniestro.tipoRespuestaReembolso != nextProps.siniestro.tipoRespuestaReembolso) {
			let tipoRespuesta = nextProps.siniestro.tipoRespuestaReembolso;
			if(tipoRespuesta == "No disponible") {
				this.setState({ "estatus": "En proceso" });
			} else if(tipoRespuesta == "Cubierto") {
				this.setState({ "estatus": "Aprobado" });
			} else if(tipoRespuesta == "Activado / No Cubierto") {
				this.setState({ "estatus": "Rechazado" });
			}

			this.setState({ "montoAutorizado": this.format(nextProps.siniestro.impSiniestroAutorizado) });
			this.setState({ "montoReclamado": this.format(nextProps.siniestro.impReclamado) });
		}
	}

	componentWillMount = () => {
		let tipoRespuesta = this.props.siniestro.tipoRespuestaReembolso;
		if(tipoRespuesta == "No disponible") {
			this.setState({ "estatus": "En proceso" });
		} else if(tipoRespuesta == "Cubierto") {
			this.setState({ "estatus": "Aprobado" });
		} else if(tipoRespuesta == "Activado / No Cubierto") {
			this.setState({ "estatus": "Rechazado" });
		}

		this.setState({ "montoAutorizado": this.format(this.props.siniestro.impSiniestroAutorizado) });
		this.setState({ "montoReclamado": this.format(this.props.siniestro.impReclamado) });
	}

	render() {
		return <div className="container mt-50">
			<div className="datos-siniestro-wrapper datos-rembolso">
				<h4>Datos Reembolso</h4>
				<div className="card datos-siniestro">
					<h6><i><img src={require("../img/icon-tramite.svg")}></img></i>Datos de siniestro</h6>
					<ul>
						<li>
							<p className="pull-left">Nombre del asegurado:</p>
							<p className="pull-right">{this.props.siniestro.nombreCompletoAsegurado}</p>
						</li>
						<li>
							<p className="pull-left">Número de reclamación:</p>
							<p className="pull-right">{this.props.siniestro.numReclamacion}</p>
						</li>
						<li>
							<p className="pull-left">Folio de reclamación:</p>
							<p className="pull-right">{this.props.siniestro.numSolicitud}</p>
						</li>
						<li>
							<p className="pull-left">Tipo de trámite:</p>
							<p className="pull-right">Reembolso</p>
						</li>
						<li>
							<p className="pull-left">Monto reclamado:</p>
							<p className="pull-right">{this.state.montoReclamado}</p>
						</li>
						<li>
							<p className="pull-left">Fecha de registro:</p>
							<p className="pull-right">{this.props.siniestro.fechaAperturaReembolso}</p>
						</li>
						<li>
							<p className="pull-left">Fecha promesa de respuesta:</p>
							<p className="pull-right">{this.props.siniestro.fechaPromesaRespuesta}</p>
						</li>
						<li>
							<p className="pull-left">Monto Autorizado:</p>
							<p className="pull-right">{this.state.montoAutorizado}</p>
						</li>
						<li>
							<p className="pull-left">Estatus:</p>
							<p className="pull-right">{this.state.estatus}</p>
						</li>
						<li>
							{ this.state.estatus == "Aprobado" &&
								<p className="txt">
									Consulta tu cuenta bancaria en los próximos días.
								</p>
							}
							{ this.state.estatus == "Rechazado" &&
								<p className="txt">
									Para aclaraciones llamanos de lunes a domingo las 24 horas al 52-27-33-33 o 01 (55) 5227 9000 opción 3 y luego opción 1.
								</p>
							}
							{ this.state.estatus == "No disponible" &&
								<p className="txt">
									Verifica en los próximos días el proceso de tu trámite.
								</p>
							}
						</li>
					</ul>
				</div>
			</div>
		</div>;
	}
}
export default connect(mapState)(DetalleReembolso);



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/detalleReembolso.cmpt.js